import React, { useState } from "react";
import Button from "../../../components/CustomButtons/Button";
import { clone } from "lodash";
import { IconButton } from "@material-ui/core";
import NotificationAsk from "../../../components/Notification/NotificationAsk";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import GuarantorPopup from "./GuarantorPopup";

const Guarantors = (props) => {
    const [askDelete, setAskDelete] = useState(-1);
    const [popupOpen, setPopupOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(-1);
    const { data, field, setData, index } = props;

    const guarantors = data[field] && data[field][index] && data[field][index].guarantors
        ? data[field][index].guarantors
        : [];

    const saveGuarantor = (g) => {
        const newData = clone(data);
        if (!newData[field][index].guarantors) newData[field][index].guarantors = [];
        if (editIndex === -1) {
            newData[field][index].guarantors.push(g);
        } else {
            newData[field][index].guarantors[editIndex] = g;
        }
        setData(newData);
        setPopupOpen(false);
        setEditIndex(-1);
    };

    return <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
            <Button
                color="rose"
                onClick={() => { setEditIndex(-1); setPopupOpen(true); }}
            >ADD OTHER GUARANTOR</Button>
            {guarantors.map((g, i) => {
                return <div key={`g-${i}`} className="boxed" style={{ width: "100%" }}>
                    <div style={{ float: "right" }}>
                        <IconButton
                            onClick={() => { setEditIndex(i); setPopupOpen(true); }}
                        >
                            <i className="fa fa-edit"></i>
                        </IconButton>
                        <IconButton
                            onClick={() => { setAskDelete(i); }}
                        >
                            <i className="fa fa-trash"></i>
                        </IconButton>
                    </div>
                    <h4>{g.name}</h4>
                </div>;
            })}
        </GridItem>

        <GuarantorPopup
            open={popupOpen}
            close={() => { setPopupOpen(false); setEditIndex(-1); }}
            onSave={saveGuarantor}
            initial={editIndex !== -1 ? guarantors[editIndex] : null}
        />

        {askDelete !== -1 && <NotificationAsk
            open={true}
            close={() => { setAskDelete(-1); }}
            title="Are you sure?"
            message="Do you want to remove this guarantor?"
            success={() => {
                const newData = clone(data);
                newData[field][index].guarantors = newData[field][index].guarantors.filter((g, ii) => ii !== askDelete);
                setData(newData);
                setAskDelete(-1);
            }}
        />}
    </GridContainer>;
};

export default Guarantors;
